export function getImageStyleClasses(imageStyle) {
  if (!imageStyle) {
    return { className: "", style: {} };
  }

  const classes = [];

  // Numeric fields divided by 100
  const opacity = imageStyle.opacity / 100;
  classes.push(`opacity-[${opacity}]`);

  const brightness = imageStyle.brightness / 100;
  classes.push(`brightness-[${brightness}]`);

  const contrast = imageStyle.contrast / 100;
  classes.push(`contrast-[${contrast}]`);

  // Blur remains as tailwind class if not 'none'
  if (imageStyle.blur && imageStyle.blur !== "none") {
    classes.push(imageStyle.blur);
  }

  const grayscale = imageStyle.grayscale / 100;
  classes.push(`grayscale-[${grayscale}]`);

  // hue_rotate remains in degrees
  if (imageStyle.hue_rotate !== undefined) {
    classes.push(`hue-rotate-[${imageStyle.hue_rotate}deg]`);
  }

  const invert = imageStyle.invert / 100;
  classes.push(`invert-[${invert}]`);

  const saturate = imageStyle.saturate / 100;
  classes.push(`saturate-[${saturate}]`);

  const sepia = imageStyle.sepia / 100;
  classes.push(`sepia-[${sepia}]`);

  return {
    className: classes.join(" "),
    style: {},
  };
}
